import { lazy } from 'react';

const RELOAD_KEY = 'finly:chunk-reload-at';
const RELOAD_COOLDOWN_MS = 30000;

/**
 * Yeni sürüm yayınlandığında açık sekmedeki eski parça (chunk) adresleri artık yok.
 * İlk yükleme hatasında sayfayı bir kez yenileyerek yeni sürümü alır;
 * kısa sürede tekrar başarısız olursa hatayı ErrorBoundary'ye bırakır (sonsuz döngü yok).
 */
export function lazyWithReload(importer) {
  return lazy(async () => {
    try {
      return await importer();
    } catch (err) {
      let last = 0;
      try {
        last = Number(window.sessionStorage.getItem(RELOAD_KEY)) || 0;
      } catch {
        last = Date.now();
      }
      if (Date.now() - last > RELOAD_COOLDOWN_MS) {
        try {
          window.sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
        } catch {
          throw err;
        }
        window.location.reload();
        return new Promise(() => {});
      }
      throw err;
    }
  });
}
